<template>
  <div>

    <div class="flex flex-wrap -mx-2">
      <div class="w-full px-2" :class="{ 'lg:w-1/3 xl:w-1/4': !fullWidthCols }">
        <div class="box">

          <template v-if="mode === 'create' || mode === 'edit'">
            <p class="text-2xl font-bold mb-3">SELECT SUPPLIER</p>

            <model-select
              model="supplier"
              form-name="supplier"
              :validation-rules="selectRequired ? 'required' : ''"
              v-model="supplierSelect"
              :list.sync="supplierList"
              :search-on-mount="true"
              :is-taggable="!inModal"
              @select="selectSupplier"
              @remove="deselectSupplier"
              :button-new="!inModal"
              :button-edit="!inModal"
            ></model-select>
          </template>

          <template v-if="showSupplierInfo && supplier && supplier.id">
            <p
              class="text-lg tracking-tight text-center text-red-500 leading-tight pb-1 mb-6 border-b border-theme-200 light:border-theme-600"
              v-if="supplier.unpaid_total"
            >
              Unpaid total: <strong>{{ $formatMoney(supplier.unpaid_total) }}</strong>
            </p>
            <contact-details :contact="supplier" contactType="supplier" :edit="true" @updated="get(editSupplierID)"></contact-details>
          </template>

        </div>
      </div>
      <div class="w-full px-2" :class="{ 'lg:w-2/3 xl:w-3/4': !fullWidthCols }" v-if="editSupplierID">
        <div class="box">
          <ul class="flex select-none mb-8">
            <li class="flex-1 mr-2">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'supplier-accounts' }"
                @click="tabs.top.active = 'supplier-accounts'"
                >
                Supplier Accounts
              </a>
            </li>
            <li class="flex-1 mr-2" v-if="showStatementTab && hasPermission('contact.settlement-of-account')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'statement-of-account' }"
                @click="tabs.top.active = 'statement-of-account'"
                >
                Statement of account
              </a>
            </li>
            <li class="flex-1" v-if="showMassSettleTab && hasPermission('contact.mass-settle')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'unsettled-invoices' }"
                @click="tabs.top.active = 'unsettled-invoices'"
                >
                Unsettled Invoices
              </a>
            </li>
          </ul>
          <div v-if="tabs.top.active === 'supplier-accounts'">
            <supplier-accounts-list
              :supplierID="editSupplierID"
              :selectable="selectable"
              :selectedAccountID="supplierAccountIDSelected"
              :inModal="inModal"
            ></supplier-accounts-list>
          </div>
          <div v-if="tabs.top.active === 'statement-of-account'">
            <statement-of-account
              :contactID="editSupplierID"
              contactType="supplier"
            ></statement-of-account>
          </div>
          <div v-if="tabs.top.active === 'unsettled-invoices'">
            <invoice-settle
              :contactID="editSupplierID"
              contactType="supplier"
              paymentType="expense"
            ></invoice-settle>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import path from 'path'
const SupplierAccountsList = resolve => require(['@/components/pages/suppliers/AccountList'], resolve)
const ContactDetails = resolve => require(['@/components/pages/ContactInformation'], resolve)
const InvoiceSettle = resolve => require(['@/components/pages/invoices/Settle'], resolve)
const StatementOfAccount = resolve => require(['@/components/pages/reports/StatementOfAccount'], resolve)

export default {
  name: 'supplier-details',
  props: {
    supplierID: {},
    supplierAccountID: {},
    showMassSettleTab: {
      type: Boolean,
      default: true,
    },
    showStatementTab: {
      type: Boolean,
      default: true,
    },
    createAlert: {
      type: Boolean,
      default: true,
    },
    inModal: Boolean,
    fullWidthCols: Boolean,
    showSupplierInfo: {
      type: Boolean,
      default: true,
    },
    selectable: Boolean,
    selectRequired: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    SupplierAccountsList,
    ContactDetails,
    InvoiceSettle,
    StatementOfAccount,
  },
  data() {
    return {
      mode: null,
      editSupplierID: null,
      supplier: null,
      supplierSelect: null,
      supplierAccounts: [],
      supplierList: [],
      supplierAccountIDSelected: null,
      tabs: {
        top: {
          active: 'supplier-accounts',
        },
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      },
    }
  },
  watch: {
    supplierID() {
      this.setMode()
    },
    supplierAccountID(v) {
      this.supplierAccountIDSelected = v
      if (v) {
        this.getSupplierByAccountID(v)
      } else if (this.editSupplierID) {
        this.supplierAccountIDSelected = null
      }
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.setMode()
    this.$EventBus.$on('supplier.deselect', this.deselectSupplier)
  },
  destroyed() {
    this.$EventBus.$off('supplier.deselect')
  },
  methods: {
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'supplier' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.supplierID) {
        this.editSupplierID = this.supplierID
        this.mode = 'edit'
      } else if (this.$route.params.supplierID) {
        this.editSupplierID = this.$route.params.supplierID
      }

      // unique to suppliers
      if (this.supplierAccountIDSelected && this.editSupplierID) {
        this.mode = 'edit'
      }

      if (this.mode === 'create') {
        this.supplier = {}
        this.supplierSelect = null
        // get all suppliers
        // this.searchSuppliers('')
      } else {
        this.get(this.editSupplierID)
      }
    },
    selectSupplier(supplier) {
      this.get(supplier.id)
    },
    deselectSupplier() {
      this.supplier = {}
      this.supplierSelect = null
      this.editSupplierID = null
      this.supplierAccountIDSelected = null
      this.$emit('selected', null)
    },
    get(supplierID) {
      return new Promise((resolve, reject) => {
        axios.get('suppliers/' + supplierID)
          .then((response) => {
            const supplier = response.data
            this.supplier = Object.assign({}, supplier)
            // set supplier
            const display_name = '#' + supplier.id + ' ' + supplier.first_name + ' ' + supplier.last_name + (supplier.company_name ? ' (' + supplier.company_name + ')' : '')
            const newSupplier = {id: supplier.id, display_name}
            this.supplierList = []
            this.supplierList.push(newSupplier)
            this.supplierSelect = Object.assign({}, newSupplier)

            this.editSupplierID = this.supplier.id

            if (this.selectable && this.supplierAccountIDSelected) {
              // check if selected account belongs to this supplier
              axios.get(path.join('supplier-accounts', String(this.supplierAccountIDSelected)))
                .then((response) => {
                  if (response.data.supplier_id !== this.editSupplierID) {
                    this.supplierAccountIDSelected = null
                    this.$emit('selected', null)
                  }
                })
            }

            // get unpaid total
            axios.get('reports/supplier/' + this.supplier.id + '/unpaid-total')
              .then(response => {
                this.$set(this.supplier, 'unpaid_total', response.data)
              })

            resolve(supplier)
          })
          .catch((error) => reject(error))
      })
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.supplier = {}
              this.supplierSelect = null
            } else {
              this.get(this.editSupplierID)
            }
          }
        })
    },
    getSupplierByAccountID(accountID) {
      axios.get(path.join('supplier-accounts', String(accountID)))
        .then(response => {
          if (response.data) {

            const account = response.data
            if (this.editSupplierID !== account.supplier_id) {
              this.editSupplierID = account.supplier_id
              this.setMode()
            }
          }
        })
    }
  }
}
</script>
